const SupportIQPage = () => {
  return (
    <div data-testid="supportiq-page" className="pt-20 min-h-screen bg-slate-950">
      <iframe
        src="https://supportiq-2.emergent.host/"
        title="Support IQ"
        className="w-full h-[calc(100vh-80px)] border-0"
        allow="microphone; camera"
      />
    </div>
  );
};

export default SupportIQPage;
